import { publicCallbackUrlIssue } from "../../packages/common/src/public-callback-url";

/** 复用服务端的纯 URL 校验并转换为中文提示；不解析 DNS、不访问回调目标。 */
export function platformCallbackUrlIssue(value: string): string | null {
  const issue = publicCallbackUrlIssue(value);
  switch (issue) {
    case null:
      return null;
    case "Callback URL must use HTTP or HTTPS":
      return "回调地址仅支持 HTTP 或 HTTPS，请使用 http:// 或 https:// 开头的公网地址";
    case "Callback credentials and fragments are forbidden":
      return "回调地址不能包含用户名、密码或 URL 片段（#）";
    case "Callback URL must use a public hostname":
      return "回调地址必须使用公网地址，不能使用内网、本机或元数据地址";
    default:
      return "请输入有效的 HTTP 或 HTTPS 回调地址";
  }
}
